module.exports = __webpack_public_path__ + "img/YTO-icon.2730267f.png";